
import $ from 'jquery';

$('a[href*=\\#]:not([href=\\#])').on('click', function (e) {
	if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
		let $target = $(this.hash);
		let offsetTop = $(".c-header").height();
		$target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');
		if ($target.length) {
			if ($('body').hasClass('is-fixed') && $(this).hasClass('js-header-link')) {
				$(".c-header").trigger('menu-close');
			}
			let targetOffset = $target.offset().top - offsetTop;

			if ($(window).outerWidth() < 961) {
				targetOffset -= 20
			}
			$('html,body').animate({ scrollTop: targetOffset }, 1000);
			return false;
		}
	}
});

$(function () {
	function handleAnchorLink() {
		const scrolls = $('.js-scroll')

		if (scrolls.length) {
			let flags = []
			let secid = ''

			scrolls.each(function () {
				const _this = $(this)
				const pos = _this.offset().top - $('.js-header').innerHeight()

				if (pos <= $(window).scrollTop()) {
					flags.push(_this.attr('id'))

				} else {
					flags = flags.filter(item => item !== _this.attr('id'))
				}

				secid = [...new Set(flags)];
				$('.js-header-link').removeClass('is-active')
				$(`a[href="#${secid[secid.length - 1]}"]`).addClass('is-active')
			})
		}
	}

	handleAnchorLink()

	$(window).on('resize scroll', function () {
		handleAnchorLink()
	})
})
